import { AppServerAPI } from '@sdbn/common'
import { Injectable } from '@angular/core'
import { Subject } from 'rxjs';

import { TransportCabotageCheck } from "./transportmanagement.model"

@Injectable({
    providedIn: 'root'
})
export class CheckCabotageAPIService {

  constructor (
    private appServerAPI: AppServerAPI
  ) {
  }

  public execute(cabotageCheck: TransportCabotageCheck) : Subject<boolean> {
    const subject = new Subject<boolean>();
    this.appServerAPI.execute<boolean>('/TMC-YARD/TransportManagement/CheckCabotage/execute', cabotageCheck).subscribe(response => {
      subject.next( response);
    },
      error => {
        subject.error(error);
      }
    );
    return subject;
  }

}
